import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import withMatch from '@/hocs/withMatch';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Spinner from './shared/ui/Spinner';
import { colorPalette } from '../styles/styleGuide';
import { performApiRequest } from '../redux/apiData';
var IFRAMEPADDING = 30;
var dispatchToProps = function dispatchToProps(dispatch) {
  return {
    getNotifications: function getNotifications(projectSlug) {
      dispatch(performApiRequest('getNotifications', {
        projectSlug: projectSlug
      }));
    }
  };
};
var IFrameBlock = /*#__PURE__*/function (_Component) {
  function IFrameBlock() {
    var _this;
    _classCallCheck(this, IFrameBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IFrameBlock, [].concat(args));
    _defineProperty(_this, "state", {
      iFrameHeight: 0,
      isFrameVisible: false,
      isLoading: true,
      componentMinHeight: _this.props.type === 'forum' ? 132 : _this.props.type === 'messageCenter' ? 432 : _this.props.type === 'documentCenter' ? 320 : 0
    });
    _defineProperty(_this, "handleIframeEvent", function (event) {
      var _this$props = _this.props,
        type = _this$props.type,
        iframe = _this$props.iframe,
        getNotifications = _this$props.getNotifications,
        match = _this$props.match;
      var data = event.data;
      if (data.type === 'SET_HEIGHT' && data.url.includes(iframe)) {
        var iFrameHeight = type === 'documentCenter' ? Math.max(500, data.height) : data.height;
        _this.setState({
          iFrameHeight: iFrameHeight,
          isFrameVisible: !!data.height
        }, function () {
          setTimeout(function () {
            _this.setState({
              isLoading: false
            });
          }, 500);
        });
      }
      if (data.type === 'LOAD' || data.type === 'XHR_RESPONSE') {
        getNotifications(String(match.params.projectSlug));
      }
    });
    _defineProperty(_this, "getIframeWidth", function (width) {
      if (width >= 1180) {
        return 1180;
      } else if (width >= 980 && width < 1180) {
        return 941;
      } else if (width >= 680 && width < 980) {
        return 641;
      } else {
        return 320;
      }
    });
    return _this;
  }
  _inherits(IFrameBlock, _Component);
  return _createClass(IFrameBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('message', this.handleIframeEvent, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleIframeEvent, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        renderWidth = _this$props2.renderWidth,
        type = _this$props2.type,
        iframe = _this$props2.iframe;
      var _this$state = this.state,
        componentMinHeight = _this$state.componentMinHeight,
        isFrameVisible = _this$state.isFrameVisible,
        iFrameHeight = _this$state.iFrameHeight,
        isLoading = _this$state.isLoading;
      return __jsx(Block, {
        minHeight: componentMinHeight + IFRAMEPADDING,
        "data-e2e-block-iframe": true,
        "data-id": "components_IFrameBlock_Block"
      }, isLoading && __jsx(SpinnerContainer, {
        "data-id": "components_IFrameBlock_SpinnerContainer"
      }, __jsx(Spinner, {
        monochrome: true,
        color: colorPalette.lightBlue,
        size: "small",
        "data-id": "components_IFrameBlock_Spinner"
      })), __jsx(Frame, {
        visible: isFrameVisible,
        title: type,
        src: iframe,
        width: this.getIframeWidth(renderWidth),
        height: iFrameHeight + IFRAMEPADDING,
        "data-id": "components_IFrameBlock_Frame"
      }));
    }
  }]);
}(Component);
export default withMatch(connect(null, dispatchToProps)(IFrameBlock));
var Block = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  min-height: ", "rem;\n\n  > div {\n    display: flex;\n  }\n"])), function (props) {
  return props.minHeight ? props.minHeight : 200;
});
var Frame = styled.iframe(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  margin: 0 auto;\n  border: none !important;\n  opacity: ", ";\n  transition: opacity 0.3s 0.5s ease-in;\n"])), function (props) {
  return props.visible ? '1' : '0';
});
var SpinnerContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n\n  > div {\n    width: 40rem;\n  }\n"])));